document.addEventListener("DOMContentLoaded", () => {
	const rememberVehicleSelection = true;
	const includeDetailedParams =true;

	const isFrench = window.shopLocale === "fr";
	const localePrefix = isFrench ? "/fr" : "";
	
	const wrappers = document.querySelectorAll(".vehicle-selector-wrapper");
	const collectionHandle = "all";
	const sharedState = { filterParams: new URLSearchParams() };

	document.addEventListener("click", (e) => {
		const btn = e.target.closest("#vehicle-selector-submit-btn");
		if (btn?.dataset.url) window.location.href = btn.dataset.url;

		const skuBtn = e.target.closest("#sku-search-btn");
		if (skuBtn) {
			const skuInput = document.querySelector("#sku-search-input");
			if (skuInput?.value) {
				searchBySku(skuInput.value.trim());
			}
		}
	});

	document.addEventListener("keydown", (e) => {
		if (e.key === "Enter" && e.target.matches("#sku-search-input")) {
			const skuInput = e.target;
			if (skuInput?.value) {
				searchBySku(skuInput.value.trim());
			}
		}
	});

	loadFilterForm(collectionHandle);

	function searchBySku(sku) {
  // Clear any existing vehicle selections
  sharedState.filterParams = new URLSearchParams();

  // Search specifically for SKU using the product's metafield
  fetch(`/search?q=variants.sku:${encodeURIComponent(sku)}&type=product&view=ajax`)
    .then((res) => res.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, "text/html");
      const productLinks = Array.from(doc.querySelectorAll('a[href*="/products/"]'))
        .map((link) => link.href.split("?")[0])
        .filter((url, i, arr) => arr.indexOf(url) === i);

      if (productLinks.length === 1) {
        window.location.href = productLinks[0];
      } else {
        alert("No product found matching SKU");
      }
    })
    .catch((err) => {
      console.error("SKU search error:", err);
      alert("Error searching by SKU");
    });
}

	function loadFilterForm(handle) {
		fetch(`${localePrefix}/collections/${handle}?${sharedState.filterParams}&view=ajax`)
			.then((res) => res.text())
			.then((html) => {
				const doc = new DOMParser().parseFromString(html, "text/html");
				const filterForm = doc.querySelector(".vehicle-selector-form");

				if (!filterForm) return;

				wrappers.forEach((wrapper) => {
					const container = wrapper.querySelector(".vehicle-selector-form-container");
					container.innerHTML = "";
					const clonedForm = filterForm.cloneNode(true);
					container.appendChild(clonedForm);

					const headingText = wrapper.dataset.heading;
					const headingEl = clonedForm.querySelector(".heading");
					if (headingText && headingEl) headingEl.textContent = headingText;

					attachFilterListeners(clonedForm, handle);

					if (rememberVehicleSelection) {
						restoreSelectorState(clonedForm);
					}
				});
			})
			.catch((err) => console.error("Error loading filters:", err));
	}

	function toggleVisibility(select, visible) {
		const wrapper = select?.closest(".filter-group");
		if (wrapper) {
			wrapper.style.display = visible ? "" : "none";
			wrapper.classList.toggle("filter-group--visible", visible);
			select.disabled = !visible;
		}
	}

	function initializeDropdownState(form) {
		const selects = {
			year: form.querySelector('select[name*="year"]'),
			make: form.querySelector('select[name*="make"]'),
			model: form.querySelector('select[name*="model"]'),
			prop1: form.querySelector('select[name*="prop1"]'),
			prop2: form.querySelector('select[name*="prop2"]')
		};
		const submitBtn = form.querySelector("#vehicle-selector-submit-btn");

		const updateState = () => {
			const yearVal = selects.year?.value;
			const makeVal = selects.make?.value;
			const modelVal = selects.model?.value;
			const readyForProps = yearVal && makeVal && modelVal;

			selects.make && (selects.make.disabled = !yearVal);
			selects.model && (selects.model.disabled = !(yearVal && makeVal));

			["prop1", "prop2"].forEach((key) => {
				const select = selects[key];
				if (select) {
					select.disabled = !readyForProps;
					toggleVisibility(select, readyForProps && select.options.length > 1);
				}
			});

			if (submitBtn?.dataset.url) submitBtn.disabled = false;
		};

		submitBtn && (submitBtn.disabled = true);
		["year", "make", "model"].forEach((key) =>
			selects[key]?.addEventListener("change", updateState)
		);

		updateState();
	}

	function attachFilterListeners(form, handle) {
		// Define models to remove for each make
		const excludedModels = {
			Dodge: ["1500", "1500 Classic", "2500"],
			RAM: ["Ram 1500", "Ram 1500 Classic", "Ram 2500"]
		};

		const applyFilters = async (changedField) => {
			const fieldsOrder = ["year", "make", "model", "prop1", "prop2"];
			const changedIndex = fieldsOrder.findIndex((f) => changedField.includes(f));
			if (changedIndex === -1) return;

			const newParams = new URLSearchParams();
			form.querySelectorAll("select").forEach((select) => {
				const index = fieldsOrder.findIndex((f) => select.name.includes(f));
				if (index <= changedIndex && select.value) {
					newParams.append(select.name, select.value);
				}
			});

			sharedState.filterParams = newParams;

			try {
				const res = await fetch(`${localePrefix}/collections/${handle}?${newParams}&view=ajax`);
				const html = await res.text();
				const doc = new DOMParser().parseFromString(html, "text/html");
				const ajaxForm = doc.querySelector(".vehicle-selector-form");

				if (!ajaxForm) return;

				document.querySelectorAll(".vehicle-selector-form").forEach((existingForm) => {
					const selects = existingForm.querySelectorAll("select");

					selects.forEach((select) => {
						const name = select.name;
						const index = fieldsOrder.findIndex((f) => name.includes(f));

						// Update the select options based on the previous field's values
						// This is to ensure that if a field is changed, all subsequent fields are reset
						// Repopulate the select with new options if user unselects a value
						// Exception: Update prop1 if prop2 is changed
						// See README.MD "Vehicle selector checklist" and "Prop 1 and Prop 2 exceptions" section notes
						// There are exceptions for Dodge, RAM, and Volkswagen models
						if (
							index > changedIndex ||
							(name === changedField && !select.value) ||
							(changedField.includes("prop2") && name.includes("prop1") && !select.value)
						) {
							const newSelect = ajaxForm.querySelector(`select[name="${name}"]`);
							select.innerHTML = newSelect?.innerHTML || "";
							select.disabled = !newSelect;

							if (name.includes("model")) {
								const make = existingForm.querySelector('select[name*="make"]')?.value;
								const year = parseInt(
									existingForm.querySelector('select[name*="year"]')?.value,
									10
								);

								const toRemove = excludedModels[make] || [];

								// Additional Volkswagen logic
								if (make === "Volkswagen" && year) {
									const vwModelRules = [
										{ model: "Golf SportWagen", min: 2015, max: 2019 },
										{ model: "Golf Alltrack", min: 2017, max: 2019 }
									];

									select.querySelectorAll("option").forEach((option) => {
										const rule = vwModelRules.find(
											(r) => r.model.toLowerCase() === option.textContent.trim().toLowerCase()
										);

										if (rule && (year < rule.min || year > rule.max)) {
											option.remove();
										}
									});
								}

								// Remove other excluded models
								select.querySelectorAll("option").forEach((option) => {
									if (toRemove.includes(option.value) || toRemove.includes(option.textContent)) {
										option.remove();
									}
								});
							}

							toggleVisibility(select, !!newSelect?.options.length);
						}
					});
				});

				initializeDropdownState(form);

				const productUrls = Array.from(doc.querySelectorAll('a[href*="/products/"]'))
					.map((link) => link.href.split("?")[0])
					.filter((url, i, arr) => arr.indexOf(url) === i);

				// Set submit button if all required selects have values and only 1 product URL is found
				const submitBtn = form.querySelector("#vehicle-selector-submit-btn");
				const allSelected = Array.from(form.querySelectorAll("select:not(:disabled)")).every(
					(s) => s.value
				);

				if (submitBtn) {
					if (allSelected && productUrls.length >= 1) {
						const [year, make, model] = ["year", "make", "model"].map(
							(k) => form.querySelector(`select[name*="${k}"]`)?.value || ""
						);

						const seating = doc.querySelector(".product-meta")?.dataset.seating || null;
						const supertruck = doc.querySelector(".product-meta")?.dataset.supertruck || null;

						const complementaryProductIds = Array.from(doc.querySelectorAll('.product-meta'))
							.flatMap(el => el.dataset.complementaryProductIds.split(',').filter(Boolean))
							.filter((id, i, arr) => arr.indexOf(id) === i); // dedupe
						const showVariantsOnCollection = Array.from(doc.querySelectorAll('.product-meta')).some(el => el.dataset.showVariantsOnCollection === 'true');

						let hasComplementaryProduct = false;

						if (complementaryProductIds.length > 0) {
							hasComplementaryProduct = true;
						}

						const goToCollection = productUrls.length > 1 || complementaryProductIds.length > 0 || showVariantsOnCollection;

						const productInfo = {
							// link to the product page
							url: `${productUrls[0]}?${new URLSearchParams({ year, make, model })}`,
							// link to the collections page
							// url: `${localePrefix}/collections/${handle}?${newParams}`,
							// NOTE: go to collections page if there are multiple products, if it has complementary products, or any variants are displayed on the collections page
							url: goToCollection ? `${localePrefix}/collections/${handle}?${newParams}` : `${productUrls[0]}?${new URLSearchParams({ year, make, model })}`,
							warrantyUrl: `${localePrefix}/collections/${handle}?${newParams}`,
							year,
							make,
							model,
							seating,
							supertruck
						};

						submitBtn.dataset.url = productInfo.url;
						submitBtn.disabled = false;

						sessionStorage.setItem("selectedProduct", JSON.stringify(productInfo));
					} else {
						delete submitBtn.dataset.url;
						submitBtn.disabled = true;
						sessionStorage.removeItem("selectedProduct");
					}

					if (rememberVehicleSelection) {
						saveSelectorState(form);
					}
				}
			} catch (err) {
				console.error("Error applying filters:", err);
			}
		};

		form.querySelectorAll("select").forEach((select) =>
			select.addEventListener("change", (e) => {
				const submitBtn = form.querySelector("#vehicle-selector-submit-btn");
				if (submitBtn) {
					submitBtn.disabled = true;
					delete submitBtn.dataset.url;
					sessionStorage.removeItem("selectedProduct");
				}
				applyFilters(e.target.name);
			})
		);

		initializeDropdownState(form);
	}

	function saveSelectorState(form) {
		const state = {};
		form.querySelectorAll("select").forEach((select) => {
			state[select.name] = {
				value: select.value,
				options: Array.from(select.options).map((opt) => ({
					value: opt.value,
					text: opt.text,
					disabled: opt.disabled
				}))
			};
		});

		const submitBtn = form.querySelector("#vehicle-selector-submit-btn");
		if (submitBtn?.dataset.url) {
			state.submitUrl = submitBtn.dataset.url;
		}

		sessionStorage.setItem("vehicleSelectorState", JSON.stringify(state));
	}

	function restoreSelectorState(form) {
		const stored = sessionStorage.getItem("vehicleSelectorState");
		if (!stored) return;

		try {
			const state = JSON.parse(stored);
			for (const [key, value] of Object.entries(state)) {
				if (key === "submitUrl") {
					const btn = form.querySelector("#vehicle-selector-submit-btn");
					if (btn) {
						btn.dataset.url = value;
						btn.disabled = false;
					}
					continue;
				}
				const select = form.querySelector(`select[name="${key}"]`);
				if (select) {
					select.innerHTML = "";
					value.options.forEach((opt) => {
						const option = document.createElement("option");
						Object.assign(option, { value: opt.value, text: opt.text, disabled: opt.disabled });
						select.appendChild(option);
					});
					select.value = value.value;
				}
			}
			initializeDropdownState(form);
		} catch (err) {
			console.error("Error restoring selector state:", err);
		}
	}
});
